import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import { RecognitionSectionProps } from '../model';
import BadgeCard from './BadgeCard';

const RecognitionSection: React.FC<RecognitionSectionProps> = ({
  consistentSites,
  firstTimeAdopter,
}) => {
  return (
    <Box type="outline" spacingInset="400">
      <Column spacing="300">
        <Heading type="h300" level={3} className="leaderboard-title">
          Recent Recognition
        </Heading>
        <Column spacing="200">
          {consistentSites && (
            <BadgeCard
              title="CONSISTENT RCC USAGE — EVERY WEEK (LAST 1 MONTH)"
              site={consistentSites.site}
              description={consistentSites.description}
            />
          )}
          {firstTimeAdopter && (
            <BadgeCard
              title="FIRST-TIME ADOPTER — NEW SITE LAST WEEK"
              site={firstTimeAdopter.site}
              description={firstTimeAdopter.description}
            />
          )}
        </Column>
      </Column>
    </Box>
  );
};

export default RecognitionSection;
